// tslint:disable
// This file is generated by buildArt script.
// Please don't edit it manually.
export var assetBundleCalloutIcons = {
    callout_icons: require("../assets/packed/callout-icons/callout-icons.json"),
};



//////////////////
// WEBPACK FOOTER
// ./src/assetBundles/assetBundleCalloutIcons.ts
// module id = 1731
// module chunks = 3